import React from 'react';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';
import { useImages } from '../context/ImageContext';

const CompareAlert1ToLifeAlertPage: React.FC = () => {
  const { getImage } = useImages();
  const coupleImage = getImage('1704WhereItWorksCouple.jpg');
  const facebookImage = getImage('facebook-image-1.png');
  
  // Reason icons
  const savingsIcon = getImage('compare-alert1-savings-icon.jpg');
  const responseIcon = getImage('compare-alert1-response-icon.jpg');
  const buttonPushIcon = getImage('compare-alert1-button-push-icon.jpg');
  const monthlyPlanIcon = getImage('compare-alert1-monthly-plan-icon.jpg');
  const helpIcon = getImage('compare-alert1-help-icon.jpg');
  const grandmotherImage = getImage('compare-alert1-grandmother-granddaughter.png');
  const womanOnStairsImage = getImage('compare-alert1-woman-on-stairs.png');

  return (
    <div className="compare-alert1-to-life-alert-page">
      {/* Hero Section */}
      <section className="compare-hero-new">
        <div className="compare-hero-container">
          <div className="compare-hero-image">
            <div className="circular-image-wrapper">
              {coupleImage ? (
                <img 
                  src={coupleImage} 
                  alt="Happy couple with Alert1" 
                  className="circular-image"
                />
              ) : (
                <div className="circular-image-placeholder" />
              )}
            </div>
          </div>
          
          <div className="compare-hero-content">
            <h1>Alert1 vs Life Alert Cost:</h1>
            <h2 className="compare-hero-subtitle">No Contracts, Free Equipment, & Save BIG with our Annual Plans!</h2>
            
            <p className="compare-hero-text">
              Comparing Life Alert to Alert1? If you are choosing a medical alert provider and want the best price 
              with 24/7/365 monitoring you can trust, the clear choice is Alert1.
            </p>
            
            <p className="compare-hero-text">
              Whether you are looking for a device with fall detection, a system that works on-the-go with built-in GPS, 
              or a combination of in-home and mobile solutions, we have a variety of alert systems to suit your needs.
            </p>
            
            <p className="compare-hero-text">
              If you're looking for a less expensive alternative to Life Alert, you are not alone. Many seniors and their 
              families call and tell us they are looking for a more affordable medical alert system after calling Life Alert. 
              LifeAlert medical alerts may be <strong>over three times the price</strong> of a comparable Alert1 system.<sup>1</sup> 
              Alert1 offers the latest medical alert systems for the best price. We are confident you will find Alert1 has 
              transparent, affordable pricing and industry-leading customer service. We have been keeping our members safe 
              and independent for 37 years!
            </p>
            
            <div style={{ textAlign: 'center', marginTop: '2rem' }}>
              <Link to="/medical-alerts" className="btn btn-primary compare-hero-btn">
                VIEW SYSTEMS
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Main Comparison Table */}
      <section className="comparison-section">
        <div className="container">
          <h2>Alert1 vs Life Alert Costs At a Glance</h2>
          <p className="section-subtitle">
            Higher pricing, inferior service, and multi-year contracts make Life Alert a less desirable option than Alert1.
          </p>
          
          <div className="comparison-table-wrapper">
            <table className="comparison-table">
              <thead>
                <tr>
                  <th></th>
                  <th className="highlight-col">Alert1</th>
                  <th>Life Alert</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><strong>Monthly Fee Starting At</strong></td>
                  <td className="highlight-col">$19.99</td>
                  <td>$69.90</td>
                </tr>
                <tr>
                  <td><strong>Activation Fee</strong></td>
                  <td className="highlight-col">$0.00</td>
                  <td>$0.00-$95.00</td>
                </tr>
                <tr>
                  <td><strong>Length of Agreement</strong></td>
                  <td className="highlight-col">1 month-1 year</td>
                  <td>3 years</td>
                </tr>
                <tr>
                  <td><strong>Stay on the Line Until Help Arrives</strong></td>
                  <td className="highlight-col">✓</td>
                  <td></td>
                </tr>
                <tr>
                  <td><strong>Pricing & Terms Posted Online</strong></td>
                  <td className="highlight-col">✓</td>
                  <td></td>
                </tr>
                <tr>
                  <td><strong>Easy to Order Online</strong></td>
                  <td className="highlight-col">✓</td>
                  <td></td>
                </tr>
                <tr>
                  <td><strong>BBB Accredited Business</strong><br /><small>A+ rating from the Better Business Bureau</small></td>
                  <td className="highlight-col">✓</td>
                  <td>Unknown</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="table-footnote">
            <sup>1</sup>Disclaimer: All information, prices, and data was last verified in December 2022. 
            To report any incorrect or outdated information, please get in touch with us. For more information 
            on Alert1's features and costs, check out our <Link to="/pricing">pricing page</Link>. To compare Alert1 
            to other medical alert systems, visit our Comparison Hub.
          </div>
        </div>
      </section>

      {/* Why Choose Alert1 Section */}
      <section className="reasons-section">
        <div className="container">
          <h2>Why Choose Alert1 Over Life Alert?</h2>
          <p className="section-intro">
            More than 234,000 families nationwide have relied on Alert1 to stay safe and live better.
          </p>
          
          <div style={{ marginTop: '3rem', textAlign: 'center' }}>
            {facebookImage && (
              <img 
                src={facebookImage} 
                alt="Facebook reviews" 
                style={{ maxWidth: '100%', height: 'auto' }}
              />
            )}
          </div>
        </div>
      </section>

      {/* 5 Reasons Section */}
      <section className="reasons-section" style={{ background: '#f9f9f9' }}>
        <div className="container">
          <h2>5 Reasons Why Alert1 is the Best Life Alert Alternative</h2>
          
          <div className="reasons-list">
            <div className="reason-item">
              <div className="reason-icon">
                {savingsIcon && (
                  <img src={savingsIcon} alt="Cost" />
                )}
              </div>
              <div className="reason-content">
                <h4><span className="reason-number">1.</span> Cost</h4>
                <p>
                  Life Alert Cost is usually higher than Alert1. Call to confirm. We have systems to meet every need, 
                  lifestyle, and budget (invaluable protection at affordable pricing)
                </p>
              </div>
            </div>

            <div className="reason-item">
              <div className="reason-icon">
                {responseIcon && (
                  <img src={responseIcon} alt="Support" />
                )}
              </div>
              <div className="reason-content">
                <h4><span className="reason-number">2.</span> Support</h4>
                <p>
                  Once a member sends an alert, our emergency response team stays on the line with them until help 
                  arrives (not all companies do this)
                </p>
              </div>
            </div>

            <div className="reason-item">
              <div className="reason-icon">
                {buttonPushIcon && (
                  <img src={buttonPushIcon} alt="Transparency" />
                )}
              </div>
              <div className="reason-content">
                <h4><span className="reason-number">3.</span> Transparency</h4>
                <p>
                  Alert1 does not charge our members for "false alarms" or multiple emergency button-pushes 
                  (some other companies do)
                </p>
              </div>
            </div>

            <div className="reason-item">
              <div className="reason-icon">
                {monthlyPlanIcon && (
                  <img src={monthlyPlanIcon} alt="Flexibility" />
                )}
              </div>
              <div className="reason-content">
                <h4><span className="reason-number">4.</span> Flexibility</h4>
                <p>
                  We provide monthly service plan options so no one is "locked in," as well as discounted annual plans 
                  (some of our competitors only offer multi-year plans). Alert1 has no long term contracts.
                </p>
              </div>
            </div>

            <div className="reason-item">
              <div className="reason-icon">
                {helpIcon && (
                  <img src={helpIcon} alt="Service" />
                )}
              </div>
              <div className="reason-content">
                <h4><span className="reason-number">5.</span> Service</h4>
                <p>
                  Our emergency Monitoring Centers are staffed by trained agents who are available 24/7/365 
                  (professional responders are always standing by)
                </p>
              </div>
            </div>
          </div>

          <div className="cta-center">
            <Link to="/medical-alerts" className="btn btn-primary">TRY US TODAY</Link>
          </div>
        </div>
      </section>

      {/* Best Alternative Section */}
      <section className="alternative-section">
        <div className="container">
          <h2>Alert1: The Best Life Alert Alternative</h2>
          <div style={{ display: 'flex', gap: '3rem', alignItems: 'flex-start', marginTop: '2rem' }}>
            <div style={{ flex: 1 }}>
              <p>
                Life Alert is often quoted for their well-remembered television slogan, "I've fallen and I can't get up."™ 
                Without high-priced commercial air time to finance, Alert1 is able to provide more affordable solutions that 
                match and even exceed the features of Life Alert's medical alert systems. Another important difference between 
                the two companies is that Life Alert requires 3 year contracts from its members, while Alert1 offers flexible 
                plan options that range from just one month at a time to 1 year-- with no contracts. We have found that some 
                members enjoy our annual plans as they offer the greatest savings, while others prefer paying one month at a time. 
                No matter which plan is selected, members are never "locked in" and may choose to cancel at any time. Life Alert 
                systems can be more than three times more expensive than those of Alert1. Choosing Alert1 as an alternative to 
                Life Alert could save you more than $140 in the first year alone!<sup>1</sup>
              </p>
              <p>
                Another benefit of choosing Alert1 over Life Alert is that our pricing and terms are clearly posted online, so 
                you can easily see the costs before you call. In addition, our easy-to-use website allows you to select from 
                in-home or on-the-go medical alert systems and add fall detection (which we highly recommend for optimal safety). 
                Once you've selected your preferred options, you can complete your order online or call us for assistance securing 
                your new device. With efficient operations and a dedication to customer service, we ship via FedEx Express 2 Day 
                Shipping, and 85% of our new orders are placed on the same day. These are value-added benefits that make Alert1 
                the ideal choice.
              </p>
            </div>
            <div style={{ flexShrink: 0 }}>
              <div className="circular-image-wrapper">
                {grandmotherImage ? (
                  <img 
                    src={grandmotherImage} 
                    alt="Grandmother and granddaughter" 
                    className="circular-image"
                  />
                ) : (
                  <div className="circular-image-placeholder" />
                )}
              </div>
            </div>
          </div>
          
          <div className="cta-center" style={{ marginTop: '3rem' }}>
            <Link to="/medical-alerts" className="btn btn-primary">VIEW SYSTEMS</Link>
          </div>
        </div>
      </section>

      {/* Value Section */}
      <section className="value-section">
        <div className="container">
          <h2>Can Life Alert Match Alert1's Value?</h2>
          <p className="section-intro">
            Alert1 offers the best value in the industry. When it comes to selecting a personal button alarm for you 
            or your loved one, what really matters most? Is it fancy advertising and "name recognition," or is it 
            world-class service, affordability, important features, and VALUE?
          </p>

          <div className="value-content-wrapper" style={{ marginTop: '3rem' }}>
            <div className="value-image">
              <div className="circular-image-wrapper">
                {womanOnStairsImage ? (
                  <img 
                    src={womanOnStairsImage} 
                    alt="Woman on stairs" 
                    className="circular-image"
                  />
                ) : (
                  <div className="circular-image-placeholder" />
                )}
              </div>
            </div>
            <div className="value-point">
              <h3>Fair and Transparent Pricing</h3>
              <p>
                Alert1's pricing starts at just $19.99 per month—significantly lower pricing than that of Life Alert. 
                Additionally, depending on one's level of service with Life Alert, you may be charged hefty programming 
                and installation fees. Alert1 discloses all of our pricing up front. There are no hidden fees or charges. 
                We offer flexible plans ranging from monthly to annual subscriptions so our members can choose the right 
                combination of price and features that works best for them.
              </p>
            </div>

            <div className="value-point">
              <h3>Flexible Plan Options</h3>
              <p>
                Unlike Life Alert, Alert1 does not require long term contracts; any user may cancel service at any time by returning the equipment. If you agree to a contract of a specified length (e.g. annual) for a discount, you may cancel early but Alert1 does not offer refunds except in the case of death or a move to a certified nursing home or assisted living facility where Alert1 service is no longer supported or allowed. Life Alert's contract term is a lengthy 3 years.
              </p>
            </div>

            <div className="value-point">
              <h3>World Class Service</h3>
              <p>
                Alert1 understands that service is everything. While you are welcome to peruse our informative website, 
                we'd be happy to have one of our knowledgeable and friendly new member specialists discuss with you which 
                medical alert would work best for your lifestyle, needs, and budget.
              </p>
            </div>

            <div className="value-point">
              <h3>Comfort and Care When You Need it Most</h3>
              <p>
                Once an alert is sent to our trained agents, Alert1 remains on the line with our members until help arrives. 
                We understand that traumatic experiences like falls and accidents may be frightening, confusing, and 
                disorienting, and we make a promise to all of our members that they will never face an emergency alone.
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default CompareAlert1ToLifeAlertPage;
